import { dimens } from '@/shahrzad-assets/shared-constants/dimens'
import {
  fontFamily,
  fontSize,
  fontsWeight,
} from '@/shahrzad-assets/shared-constants/fonts'
import { Checkbox, Col, Row } from 'antd'
import { Breakpoint } from 'react-socks'
import { styled } from 'styled-components'
import { loginTexts } from '@/shahrzad-assets/shared-constants/texts'
import PageTitle from '@/shahrzad-assets/shared_components/PageTitle'
import LegalForm from './LegalForm'

const SignUpSmallUp = () => {
  return (
    <>
      <Breakpoint small medium down>
        <PageTitle title={loginTexts.SIGNUP_LEGAL_USER_HEADING} home={false} />
        <Container>
          <Row>
            <FormContainer>
              <Description>اطلاعات زیر را کامل کنید</Description>
              <LegalForm />
            </FormContainer>
          </Row>
        </Container>
      </Breakpoint>
    </>
  )
}

export default SignUpSmallUp

const Container = styled.div`
  padding: ${dimens.SPACING_M} ${dimens.SPACING_XL} ${dimens.SPACING_XXXXXL}
    ${dimens.SPACING_XL};
  margin-top: ${dimens.PAGE_TITLE_HEIGHT};
`

const FormContainer = styled.div`
  /* padding: ${dimens.SPACING_XXXL} 0; */
  width: 100%;
`

const Description = styled.p`
  font-size: ${fontSize.NORMAL};
  margin-bottom: ${dimens.SPACING_XL};
`
